const e = [
  "576px",
  "768px",
  "992px",
  "1200px",
  "1440px"
];
e.mobile = e[0];
e.tablet = e[1];
e.largeTablet = e[2];
e.desktop = e[3];
e.largeDesktop = e[4];
const i = (t) => `${parseInt(t, 10) - 1}px`;
e.mq = {
  mobileMax: `@media (max-width: ${i(e[1])})`,
  tabletMin: `@media (min-width: ${e[1]})`,
  tabletMax: `@media (max-width: ${i(e[2])})`,
  largeTabletMin: `@media (min-width: ${e[2]})`,
  desktopMin: `@media (min-width: ${e[3]})`,
  largeDesktopMin: `@media (min-width: ${e[4]})`
};
export {
  e as default
};
